import { downloadBlob } from '@/lib/download'

export interface CsvHeader<T extends Record<string, unknown>> {
  key: keyof T
  label: string
}

function escapeCsvCell(value: unknown): string {
  if (value === null || value === undefined) return ''
  const text = String(value)
  if (!/[",\r\n]/.test(text)) return text
  return `"${text.replace(/"/g, '""')}"`
}

export function exportCsv<T extends Record<string, unknown>>(
  filename: string,
  headers: Array<CsvHeader<T>>,
  rows: T[],
) {
  const head = headers.map((header) => escapeCsvCell(header.label)).join(',')
  const body = rows.map((row) => headers.map((header) => escapeCsvCell(row[header.key])).join(','))
  const csv = `\uFEFF${[head, ...body].join('\r\n')}`
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' })
  downloadBlob(blob, filename)
}
